<div class="header" *ngIf="currentRoute != '/'">
    <!-- "New version available" band above the navbar; shown only once a new deploy is detected. -->
    <app-update-strip></app-update-strip>
    <nav class="navbar navbar-expand-lg fixed-top bg-grey navbar-nav-scrol"
        [ngClass]="isRegulated ? 'bg-grey' : 'bg-green'" aria-label="">
        <div class="container-fluid">
            <a class="navbar-brand cursor-pointer p-0" [routerLink]="['/']">
                <img loading="lazy" src="assets/images/logo-fi.svg" alt="RealWorld.fi"
                    width="186" height="38" />
            </a>

            <!-- Mobile-only action icons (below lg): search toggle + hamburger -->
            <div class="navbar-mobile-actions d-flex align-items-center d-lg-none">
                <button class="navbar-search-toggle shadow-none" type="button" (click)="toggleSearch($event)"
                    aria-label="Toggle search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <g clip-path="url(#clip0_10023_101864)">
                            <path
                                d="M15.4166 15.4167L18.3333 18.3333M17.5 9.58333C17.5 5.21108 13.9555 1.66666 9.58329 1.66666C5.21104 1.66666 1.66663 5.21108 1.66663 9.58333C1.66663 13.9556 5.21104 17.5 9.58329 17.5C13.9555 17.5 17.5 13.9556 17.5 9.58333Z"
                                stroke="white" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </g>
                        <defs>
                            <clipPath id="clip0_10023_101864">
                                <rect width="20" height="20" fill="white" />
                            </clipPath>
                        </defs>
                    </svg> </button>
                <button class="navbar-toggler shadow-none" type="button" (click)="toggleMenu($event)">
                    <span class="navbar-toggler-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M3.33337 4.16666H16.6667" stroke="white" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M3.33337 10H16.6667" stroke="white" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M3.33337 15.8333H16.6667" stroke="white" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </span>
                </button>
            </div>

            <div #navbarCollapse class="collapse navbar-collapse align-items-center "
                [ngClass]="{ show: showMenu || showSearch }">
                <div class="w-100 d-flex flex-wrap flex-lg-nowrap justify-content-end align-items-center mt-2 mt-xl-0">
                    <ul class="navbar-nav mx-0 mx-lg-4 my-2 my-lg-0 ml-auto"
                        [ngClass]="{ 'd-none d-lg-flex': !showSearch }">
                        <li>
                            <div class="search_postion">
                                <input type="search" class="form-control" placeholder="Quick Search..."
                                    (keyup)="quickSearch()" [formControl]="searchControl" #quickSearchBox>
                                <div class="search_icon_pos">
                                    <a class="btn btn-outline-success" type="submit"><img loading="lazy"
                                            src="assets/images/search.svg" alt="search"></a>
                                </div>
                                <app-search-component *ngIf="searchDropdown" [searchKey]="searchKey"
                                    [loadingStates]="loadingStates" [loader]="searchLoader" [searchData]="searchData"
                                    (resetSearch)="resetSearch()" [canShowSeeMore]='canShowSeeMore'
                                    (seeMoreEmitter)="quickSearchProcess(searchKey,$event)"></app-search-component>
                            </div>
                        </li>

                    </ul>
                    <div class="justify-content-md-end right_side_menu" [ngClass]="{ 'd-none d-lg-flex': !showMenu }">
                        <div class="custody-switcher tooptips" role="group" aria-label="Custody mode">
                            <!-- <span class="tooltips custody-switcher__help" tabindex="0" aria-label="Custody mode info">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                    <path
                                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94" />
                                </svg>

                                <span class="loan-details-tooltip">Toggle between the Custodial. and Self-Custody.
                                    environments</span>
                            </span> -->
                            <button type="button" class="custody-switcher__option"
                                [class.custody-switcher__option--active]="isRegulated" [attr.aria-pressed]="isRegulated"
                                (click)="setCustodyMode(true)">
                                Custodial.
                            </button>
                            <button type="button" class="custody-switcher__option"
                                [class.custody-switcher__option--active]="!isRegulated"
                                [attr.aria-pressed]="!isRegulated" (click)="setCustodyMode(false)">
                                Self-Custody.
                            </button>
                        </div>
                        <appkit-account-button balance="hide"></appkit-account-button>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</div>

<app-ui-modal #switchNetworkModal [hideHeader]="true" [hideFooter]="true">
    <div class="app-modal-body">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="container">
                        <div class="row my-4">
                            <div class="col-lg-12">
                                <div class="text-center">
                                    <div class="mb-3">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#ff0000"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" />
                                            <path
                                                d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                                        </svg>
                                    </div>
                                    <h4>Incorrect Network.</h4>
                                    <p class="text-center">Please change your Network to use our management application.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <ng-container *ngFor="let data of defaultNetwork">
                                    <ng-container *ngIf="walletProvider === 'io.metamask'">
                                        <div class="sign-in-wallet" (click)="switchNetwork(data)">
                                            <div class="d-flex gap-2">
                                                <p style="color: #fff;" *ngIf="data === '80002'">Switch to Polygon Amoy
                                                </p>
                                                <p style="color: #fff;" *ngIf="data === '137'">Switch to Polygon</p>
                                                <img src="assets/images/polygon.webp" width="30">
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <div *ngIf="walletProvider !== 'io.metamask'">
                                    <p class="mb-3">Unsupported chain. Logout and change network to access application
                                    </p>
                                    <div class="sign-in-wallet" (click)="logout()">
                                        <p>Log out.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</app-ui-modal>